<template>
  <section class="reseller-wrap" v-if="!isSpinner">
    <div>
      <form>
        <h2>리셀러</h2>
        <div class="reseller-box">
          <dl>
            <dt>기업명</dt>
            <dd>{{ clientInfo.hanorg }}</dd>
          </dl>
          <dl>
            <dt>사업자등록번호</dt>
            <dd>{{ clientInfo.enc_juno }}</dd>
          </dl>
          <dl>
            <dt>이메일</dt>
            <dd>{{ clientInfo.email }}</dd>
          </dl>
          <dl>
            <dt>전화번호</dt>
            <dd>{{ clientInfo.hp_no }}</dd>
          </dl>
        </div>
        <h2>정산 관리자</h2>
        <div class="reseller-box">
          <dl>
            <dt>관리자명</dt>
            <dd>
              <reseller-input
                type="text"
                v-model="resellerInfo.manager_name"
                ref="name"
              />
              <span class="message alert">{{ nameValidation }}</span>
            </dd>
          </dl>
          <dl>
            <dt>이메일</dt>
            <dd>
              <reseller-input
                type="text"
                v-model="resellerInfo.manager_email"
                ref="email"
              />
              <span class="message alert">{{ emailValidation }}</span>
            </dd>
          </dl>
          <dl>
            <dt>전화번호</dt>
            <dd>
              <!-- <reseller-input
                  type="text"
                  size="short"
                  v-model="getNumberSplit[0]"
                />
                -
                <reseller-input
                  type="text"
                  size="short"
                  v-model="getNumberSplit[1]"
                />
                -
                <reseller-input
                  type="text"
                  size="short"
                  v-model="getNumberSplit[2]"
                /> -->
              <reseller-input
                type="text"
                v-model="resellerInfo.manager_hp_no"
                ref="hp"
              />
              <span class="message alert">{{ phoneValidation }}</span>
            </dd>
          </dl>
        </div>

        <h2>정산 대상</h2>
        <div class="reseller-box">
          <target-list class="table-type2">
            <template slot="table-col">
              <col style="width: 180px" />
              <col />
              <col />
            </template>
            <template slot="table-header">
              <th></th>
              <th>수수료율</th>
              <th>정산 방식</th>
            </template>
            <template slot="table-body" v-if="this.getPolicy.length === 0">
              <tr>
                <td colspan="3" class="no-data">정산 대상이 없습니다.</td>
              </tr>
            </template>
            <template slot="table-body" v-else>
              <tr v-for="row in getPolicy" :key="row.seqno">
                <td>{{ row.detail_code_nm }}</td>
                <td>
                  {{ row.calc_level }}
                  {{ row.calc_percent }}
                  <span v-if="row.service_code === 'webmailhosting'"
                    >원/건</span
                  >
                  <span v-else>%</span>
                </td>
                <td>{{ row.calc_type_nm }}</td>
              </tr>
            </template>
          </target-list>
        </div>

        <h2>정산 계좌</h2>
        <ul class="reseller-info-text">
          <li>정산 받으실 계좌 정보를 등록해 주세요.</li>
          <li>
            계좌 정보는 직접 등록이 불가하므로 등록 및 변경이 필요하시면, 아래
            서류를
            <a
              href="mailto:reseller-acc@gabia.com"
              class="primary-color underline"
              >reseller-acc@gabia.com</a
            >으로 보내주세요. 계좌 정보가 유효하지 않은 경우, 정산이 지연될 수
            있습니다.
          </li>
        </ul>
        <p>
          ㆍ사업자등록증 사본 1부, 통장 사본 1부(대표자 또는 법인 명의),
          <a
            href="https://static.gabia.com/reseller/[가비아]결제_계좌_신청서.doc"
            class="primary-color underline"
            >결제 계좌 신청서 1부</a
          >
          (다운로드 후 작성)
        </p>
        <div class="reseller-box">
          <dl>
            <dt>은행/계좌번호</dt>
            <dd>
              <span v-if="resellerInfo.calc_bank !== null || ''"
                >{{ resellerInfo.calc_bank }}
                {{ resellerInfo.calc_account_mask }}</span
              >
              <span v-else>미등록</span>
            </dd>
          </dl>
        </div>
        <h2>세금계산서 발급</h2>
        <div class="reseller-box">
          <dl class="m-b-5">
            <dt>업태</dt>
            <dd>
              <reseller-input type="text" v-model="resellerInfo.billtax_item" />
            </dd>
          </dl>
          <dl class="m-b-5">
            <dt>업종</dt>
            <dd>
              <reseller-input
                type="text"
                v-model="resellerInfo.billtax_status"
              />
            </dd>
          </dl>
          <dl>
            <dt>주소</dt>
            <dd>
              <reseller-input
                type="text"
                v-model="resellerInfo.billtax_addr"
                size="long"
              />
            </dd>
          </dl>
        </div>
        <div class="button-area">
          <reseller-button type="primary" @click="$_modifyResellerInfo()"
            >저장</reseller-button
          >
        </div>
      </form>
    </div>
  </section>
  <Spinner :loading="isSpinner" v-else />
</template>

<script>
import ResellerInput from '@/components/Input.vue';
import ResellerButton from '@/components/Button.vue';
import TargetList from '@/components/Table.vue';
import Spinner from '@/components/Spinner.vue';
export default {
  components: {
    ResellerInput,
    ResellerButton,
    TargetList,
    Spinner
  },
  data() {
    return {
      resellerInfo: {},
      clientInfo: {},
      policy: [],
      partner_user_id: '',
      manager_phone: '',
      billtax_item: '',
      billtax_status: '',
      billtax_addr: '',
      isSpinner: false
    };
  },
  mounted() {
    this.$_getResellerInfo();
  },
  computed: {
    getPolicy() {
      let result = this.policy.filter(item => item.useon == '1');
      return result;
    },
    // getNumberSplit() {
    //   let phoneString = this.resellerInfo.manager_hp_no;
    //   if (
    //     phoneString === '' ||
    //     phoneString === null ||
    //     phoneString === undefined
    //   ) {
    //     return false;
    //   } else {
    //     let result = phoneString.split('-');
    //     return result && result.length > 0 ? result : '';
    //   }
    // },

    nameValidation() {
      if (
        this.resellerInfo.manager_name === '' ||
        this.resellerInfo.manager_name === null ||
        this.resellerInfo.manager_name === undefined
      ) {
        return '이름을 입력해주세요.';
      } else {
        return this.resellerInfo.manager_name.length > 1
          ? ''
          : '이름은 두 자 이상으로 입력해주세요';
      }
    },

    emailValidation() {
      if (
        this.resellerInfo.manager_email === '' ||
        this.resellerInfo.manager_email === null ||
        this.resellerInfo.manager_email === undefined
      ) {
        return '이메일을 입력해주세요.';
      } else {
        let email_regex = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
        return this.resellerInfo.manager_email.match(email_regex)
          ? ''
          : '이메일 입력을 확인해주세요.';
      }
    },

    phoneValidation() {
      // console.log(this.getNumberSplit)
      // if (this.getNumberSplit === false) {
      //   return '';
      // }
      // let fullNumber = `${this.getNumberSplit[0]}${this.getNumberSplit[1]}${this.getNumberSplit[2]}`
      // let regExp = /^\d{3}\d{3,4}\d{4}$/;
      // console.log(regExp.test(fullNumber));
      // return regExp.test(fullNumber) ? '' : '전화번호는 숫자만 입력해주세요.';
      if (
        this.resellerInfo.manager_hp_no === '' ||
        this.resellerInfo.manager_hp_no === null ||
        this.resellerInfo.manager_hp_no === undefined
      ) {
        return '전화번호를 입력해주세요.';
      } else {
        let phone_regex = /^\d{2,3}-\d{3,4}-\d{4}$/;
        return this.resellerInfo.manager_hp_no.match(phone_regex)
          ? ''
          : '전화번호 입력 형식을 확인해주세요. (예: 010-0000-0000)';
      }
    }
  },
  methods: {
    $_getResellerInfo() {
      this.isSpinner = true;
      this.axios
        .get('/front/reseller', {
          params: {
            //! 프로덕션에서는 자동으로 파라미터 보내줌
            partner_seq: this.partner_seq,
            partner_user_id: this.partner_user_id
          }
        })
        .then(response => {
          if (response.status == 200) {
            this.resellerInfo = response.data.data[0];
            this.clientInfo = response.data.data[0].client;
            this.policy = response.data.data[0].policy;
            this.isSpinner = false;
          } else {
            alert(
              '데이터를 가져오는 중 오류가 발생하였습니다.\n잠시 후 다시 시도해주세요.'
            );
            console.log(this.data);
          }
        })
        .catch(error => {
          console.log('reseller fetchData failed', error);
        });
    },

    $_modifyResellerInfo() {
      let params = {
        partner_seq: this.resellerInfo.partner_seq,
        manager_name: this.resellerInfo.manager_name,
        manager_hp_no: this.resellerInfo.manager_hp_no,
        manager_email: this.resellerInfo.manager_email,
        billtax_item: this.resellerInfo.billtax_item,
        billtax_status: this.resellerInfo.billtax_status,
        billtax_addr: this.resellerInfo.billtax_addr
      };

      //console.log(this.emailValidation);

      if (this.nameValidation !== '') {
        alert('이름을 확인해주세요.');
        this.$refs.name.focus();
      } else if (this.emailValidation !== '') {
        alert('이메일을 확인해주세요.');
        this.$refs.email.focus();
      } else if (this.phoneValidation !== '') {
        alert('전화번호를 확인해주세요.');
        this.$refs.hp.focus();
      } else {
        if (confirm('리셀러 정보를 변경하시겠습니까?') === true) {
          this.axios
            .put('/front/reseller', params)
            .then(response => {
              if (response.status != '200') {
                alert(
                  '데이터를 가져오는 중 오류가 발생하였습니다.\n잠시 후 다시 시도해주세요.'
                );
                location.replace('/');
              }
              alert('리셀러 정보가 변경되었습니다.');
              window.location.href = '/reseller-info';
            })
            .catch(error => {
              console.log('resellerinfo modify failed', error);
            });
        } else {
          return;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.reseller-wrap {
  h2 {
    font-weight: normal;
    font-size: 18px;
    padding-bottom: 20px;
  }

  h3 {
    font-weight: normal;
    font-size: 16px;
    color: $text-gray1;
    margin-top: 40px;
    margin-bottom: 20px;
  }
  .reseller-info-text {
    li {
      line-height: 2;
      font-size: 14px;
    }

    + p {
      padding-bottom: 20px;
      font-size: 14px;
      color: $text-gray1;
    }
  }
  .button-area {
    text-align: center;
    padding-bottom: 40px;
  }
}

.reseller-box {
  @include border-radius;
  margin-bottom: 50px;
  padding: 35px 40px;
  background: $second-background;
  border: 1px solid $border-color;

  dl {
    height: 38px;
  }

  dt,
  dd {
    display: inline-block;
    vertical-align: middle;
  }

  dt {
    width: 175px;
    color: $text-gray1;
  }

  .message {
    margin-left: 10px;
    font-size: 14px;

    &.alert {
      color: #f00;
    }
  }
}
</style>
